var widget = jQuery('.main-content .widget-shop-by-category .top-level');

function widgetColumn() {
	if(widget.length > 0){
		if (bq.helper.mq.is('lg')) {
			widget.columnize({
				columns: 4,
				lastNeverTallest: true
			});
		} else if (bq.helper.mq.is('sm')) {
			widget.columnize({
				columns: 3,
				lastNeverTallest: true
			});
		} else if (bq.helper.mq.is('xs')) {
			widget.columnize({
				columns: 2
			});
		}
	}
}

// This removes existing columnizer frameworks
function refreshWidgetColumn() {
	$.each(widget.find('.column'), function(e){
		var $this = jQuery(this),
				content = $this.contents();
		$this.replaceWith(content);
	});
	widgetColumn();
}

jQuery(document).ready(function() {
	widgetColumn();
});

jQuery(window).resize(function(){
	refreshWidgetColumn();
});
